export default __webpack_public_path__ + "static/media/globe.62b52817.svg";